import { a, getSelectedShapes, getMode, getDisplayedShapes, selectIfMouseInShapeBoundary as _selectIfMouseInShapeBoundary, setCpointMod1, setCpointMod2, setCpointFinal1, setCpointFinal2 } from "../../shared/globalState/a";
import { t } from "../../shared/globalState/t";
import { g } from "../../shared/globalState/g";
import { getMoveMatrix, getRotateMatrixByAngleRad as _getRotateMatrixByAngleRad } from "../../shared/transform";
import { getRotateMatrix } from "../../shared/transform";
import { getScaleMatrix } from "../../shared/transform";
import { getMirrorMatrix } from "../../shared/transform";

import { editModeObserver } from "../../services/moveObservers";
import { colorMagnetsObserver } from "../../services/moveObservers";
import { boundaryModeObserver } from "../../services/moveObservers";
import { observeMagnet, observeMagnetGrip } from "../../shared/magnets";

import { drawShapes, drawSingle } from "../../shared/render/shapes";

import { Point } from "../../models/Point";

import {
  canvasGetWebglCoordinates,
  canvasGetMouse,
  getLowerLeftPoint,
  projectPointToVector,
  transformPointByMatrix3,
  getPointOnLine as _getPointOnLine,
  getAngleRadians as _getAngleRadians,
  
  getFreeShapeRotateMat
} from "../../shared/common";

import { getAnglePosition } from "../../shared/magnets";

import { mat3 } from "gl-matrix";

import { textLinesCollection } from "../../libs/canvas-text/src/shared/state";


// --- rxjs
import { rerender } from "../../libs/canvas-text/src/index";
import { cnv } from "../../libs/canvas-text/src/shared/cnv";
import { addTooltipLength, addTooltipRadius, addTooltipWidthAndHeight } from "../../services/tooltip.ts";

// --- other libraries --------------------------------
import { Vector } from "../../models/Vector";
import {
  findConnectedLineEnd,
  findConnectedLineStart,
  getPStartPEndProjWhenJoinedBoth,
  getPStartPEndProjWhenJoinedEnd,
  getPStartPEndProjWhenJoinedStart,
  ifjoinedAtEnd,
  ifjoinedAtStart,
  observeJoins as _observeJoins
} from "../../services/joinObserver.ts";
import { checkSameType } from "../../services/transformator.ts";
import { CommandList as cl } from "../../models/CommandList.ts";
import { ObjectTypes } from "../../shared/enums";


function handleMouseMove(event) {
  /**
   * Функция выполняется при движении мыши. В зависимости от режима выполняются разные операции.
   * В то время, как вся отрисовка выполняется в функции drawSingle, в этой функции в зависимости
   * от режима могут выполняться трансформации.
   * ДЛЯ УЛУЧШЕНИЯ ПРОИЗВОДИТЕЛЬНОСТИ ОБРАТИТЬСЯ К ЭТОЙ ФУНКЦИИ - НАИБОЛЕЕ ВЕРОЯТНО СПОСОБЫ УЛУЧШЕНИЯ НАХОДЯТСЯ ЗДЕСЬ
   */
  requestAnimationFrame(() => {

    var mouse = canvasGetMouse(event, g.canvas);

    drawShapes();
    if (a.blockUI) return;

    /**
     * есть только две глобальные переменные такого рода - вот они, причём a.magnetPosition назначается
     * только в magnetState$ и больше нигде, а a.anglePosition назначается только в блоке ниже и больше нигде.
     * Вот что значит хорошая архитектура программы
     */
    a.magnetPosition = null;
    a.anglePosition = null;
    // назначаем глобальное свойство, чтобы позицию мыши можно было использовать в других местах
    a.mouse = mouse;


    // angle snap depends on edit mode
    if (a.angle_snap) {
      let start = null;
      if (getMode() === "edit") {
        const editShapes = a.shapes.filter(shape => shape.edit !== null);
        editShapes.forEach(shape => {
          switch (shape.type) {
            case ObjectTypes.line:
              if (shape.edit === "start") {
                start = shape.end;
              } else if (shape.edit === "end") {
                start = shape.start;
              }

              break;

            default:
              break;
          }
        });
      } else {
        start = a.start;
      }
      a.anglePosition = getAnglePosition(mouse, start);
    }


    // filter active shapes

    // magnets
    if (a.mag1) {
      if (a.mag2) {
        if (!["select", "boundary", "textEdit", "none", "break", "offset", cl.cm.networkHeating.type].includes(getMode())) {
          if (!a.pan) {
            if (!t.editBoundary) {
              // disabling magnets for currently edited shape
              observeMagnet(a.activeShapes.filter(shape => (shape.edit === null)), mouse).subscribe();
            }
          }
        }
      } else {
        if (!["select", "boundary", "textEdit", "none", "break", "offset", cl.cm.networkHeating.type].includes(getMode())) {
          if (!a.pan) {
            if (!t.editBoundary) {
              // disabling magnets for currently edited shape
              observeMagnetGrip(a.activeShapes.filter(shape => (shape.edit === null)), mouse).subscribe();
            }
          }
        }

      }
    }


    // pan
    if (a.pan) {
      const mouseWebgl = canvasGetWebglCoordinates(mouse, g.canvas);

      if (a.isPanning) {
        a.pan_start_x = mouseWebgl.x;
        a.pan_start_y = mouseWebgl.y;
        a.isPanning = false;
      }

      a.pan_tx = mouseWebgl.x - a.pan_start_x;
      a.pan_ty = mouseWebgl.y - a.pan_start_y;


      const pan_mat = mat3.fromTranslation(mat3.create(), [a.pan_tx, a.pan_ty, 0]);
      a.pan_mat = [...pan_mat];
      mat3.transpose(pan_mat, pan_mat);
      g.context.uniformMatrix3fv(g.u_pan, false, pan_mat);


    } else {
      /**
       * В процессе панорамирования реальная координата фигуры не соответствует видимому положению,
       * а значит отрисовка рамок выбора у фигур не имеет смысла, как и отображение ручек редактирования.
       */
      // enable edit mode
      editModeObserver(mouse, a.activeShapes);
      // color grips on move and copy mode
      colorMagnetsObserver(mouse, a.activeShapes);
      // enable boundary mode
      boundaryModeObserver(mouse, a.activeShapes);

    }


    if (a.isMouseDown || a.clickLineStart || a.clickRectangleStart || a.clickCircleStart || a.clickSquareStart || a.clickCircleStart) {
      switch (getMode()) {
        case "edit": {
          const editShapes = a.activeShapes.filter(shape => shape.edit !== null);
          if (editShapes.length > 0) {
            editShapes.forEach(shape => {
              switch (shape.type) {
                case ObjectTypes.line:
                  if (shape.edit === "start") {
                    if (a.angle_snap) {
                      shape.start.x = a.anglePosition.x;
                      shape.start.y = a.anglePosition.y;
                    } else {

                      shape.start = mouse;
                    }
                  } else if (shape.edit === "end") {
                    if (a.angle_snap) {
                      shape.end.x = a.anglePosition.x;
                      shape.end.y = a.anglePosition.y;
                    } else {
                      shape.end = mouse;

                    }
                  }


                  break;
                case ObjectTypes.rectangle:
                  if (a.ctrl) {
                    if (["p1", "p2", "p3", "p4"].includes(shape.edit)) {

                      const dx = mouse.x - shape.center.x;
                      const dy = mouse.y - shape.center.y;

                      shape.p1.x = shape.center.x - dx;
                      shape.p1.y = shape.center.y - dy;

                      shape.p2.x = shape.center.x + dx;
                      shape.p2.y = shape.center.y - dy;

                      shape.p3.x = shape.center.x + dx;
                      shape.p3.y = shape.center.y + dy;

                      shape.p4.x = shape.center.x - dx;
                      shape.p4.y = shape.center.y + dy;

                      shape.updateMid();

                    }
                  } else {


                    if (shape.edit === "p1") {
                      shape.p1 = { ...mouse };
                      shape.p4.x = mouse.x;
                      shape.p2.y = mouse.y;
                    } else if (shape.edit === "p2") {
                      shape.p2 = { ...mouse };
                      shape.p3.x = mouse.x;
                      shape.p1.y = mouse.y;
                    } else if (shape.edit === "p3") {
                      shape.p3 = { ...mouse };
                      shape.p2.x = mouse.x;
                      shape.p4.y = mouse.y;
                    } else if (shape.edit === "p4") {
                      shape.p4 = { ...mouse };
                      shape.p1.x = mouse.x;
                      shape.p3.y = mouse.y;
                    }
                    shape.updateMid();

                  }

                  shape.updateWidthHeight();

                  break;
                case ObjectTypes.circle:
                  if (["q1", "q2", "q3", "q4"].includes(shape.edit)) {
                    const newRadius = Math.hypot((mouse.x - shape.center.x), mouse.y - shape.center.y);
                    shape.radius = newRadius;
                  }
                  break;
                default:
                  break;
              }
            });
          }
          break;
        }
        case "select":
          a.selectFrame.end = mouse;
          drawSingle(a.selectFrame);
          break;
        case ObjectTypes.line: {
          if (a.angle_snap) {

            a.line.end.x = a.anglePosition.x;
            a.line.end.y = a.anglePosition.y;
          } else {
            a.line.end = mouse;
          }

          a.line.setSelectBoundary();
          let scaledLength = a.line.getLength() / a.zlc;
          addTooltipLength(0, a.line.selectBoundary, scaledLength, getLowerLeftPoint);


          drawSingle(a.line);
          break;
        }
        case "symline":
          if (a.angle_snap) {
            a.symline.start = a.start;
            a.symline.end.x = a.anglePosition.x;
            a.symline.end.y = a.anglePosition.y;

          } else {
            a.symline.end = mouse;
          }
          drawSingle(a.symline);
          break;
        case ObjectTypes.rectangle: {
          a.rectangle.width = mouse.x - a.start.x;
          a.rectangle.height = mouse.y - a.start.y;

          a.rectangle.p2 = new Point(a.start.x + a.rectangle.width, a.start.y);
          a.rectangle.p3 = new Point(a.start.x + a.rectangle.width, a.start.y + a.rectangle.height);
          a.rectangle.p4 = new Point(a.start.x, a.start.y + a.rectangle.height);

          let scaledWidth = a.rectangle.width / a.zlc;
          let scaledHeight = a.rectangle.height / a.zlc;

          addTooltipWidthAndHeight(0, scaledWidth, scaledHeight, a.start, mouse);

          drawSingle(a.rectangle);
          break;
        }

        case "square": {
          a.rectangle.width = (mouse.x - a.start.x);

          const height = (mouse.y - a.start.y);
          if (height < 0 && a.rectangle.width < 0) {
            a.rectangle.height = a.rectangle.width;
          } else if (height < 0 && a.rectangle.width > 0) {
            a.rectangle.height = -a.rectangle.width;
          } else if (height > 0 && a.rectangle.width < 0) {
            a.rectangle.height = -a.rectangle.width;
          } else if (height > 0 && a.rectangle.width > 0) {
            a.rectangle.height = a.rectangle.width;
          }
          a.rectangle.p2 = new Point(a.start.x + a.rectangle.width, a.start.y);
          a.rectangle.p3 = new Point(a.start.x + a.rectangle.width, a.start.y + a.rectangle.height);
          a.rectangle.p4 = new Point(a.start.x, a.start.y + a.rectangle.height);


          drawSingle(a.rectangle);
          break;
        }

        case ObjectTypes.circle: {
          a.circle.radius = Math.hypot((mouse.x - a.start.x), mouse.y - a.start.y);
          a.circle.setSelectBoundary();
          addTooltipRadius(0, a.circle.selectBoundary, a.circle.radius / a.zlc, getLowerLeftPoint);
          drawSingle(a.circle);
          break;
        }

        default:
          break;
      }
    } else {
      switch (getMode()) {
        case "move":
          if (a.clickMoveStart) {
            const move_mat = getMoveMatrix(a.clickMoveStart, mouse);
            g.context.uniformMatrix3fv(g.u_move, false, move_mat);

            rotateFreeShape(move_mat);

            getSelectedShapes().forEach(s => {
              drawSingle(s);
            })

            // --- text

            const tx = move_mat[2] * cnv.context.canvas.width / 2;
            const ty = move_mat[5] * cnv.context.canvas.height / 2;

            textLinesCollection.filter(t => t.selected).forEach(t => {
              t.edit = 1;
              t.start.x = t.moveXclick + tx;
              t.start.y = t.moveYclick - ty;
            });
            cnv.clear();
            rerender();


          }
          break;
        case "copy":
          if (a.clickCopyStart) {
            const move_mat = getMoveMatrix(a.clickCopyStart, mouse);
            g.context.uniformMatrix3fv(g.u_move, false, move_mat);


            rotateFreeShape(move_mat);

            getSelectedShapes().forEach(s => {
              drawSingle(s);
            })

            // --- text

            const tx = move_mat[2] * cnv.context.canvas.width / 2;
            const ty = move_mat[5] * cnv.context.canvas.height / 2;

            textLinesCollection.filter(t => t.selected).forEach(t => {
              t.edit = 1;
              t.start.x = t.copyClick.x + tx;
              t.start.y = t.copyClick.y - ty;
            });

            cnv.clear();
            rerender();


          }
          break;
        case "rotate":
        case "rotatecopy":
          if (a.clickRotateStart) {

            const rotate_mat = getRotateMatrix(a.clickRotateStart, mouse);
            g.context.uniformMatrix3fv(g.u_rotate, false, rotate_mat);
            a.shapes.filter(shape => shape.isSelected).forEach(shape => {
              drawSingle(shape);
            });
          }
          break;
        case "mirror":
          if (a.clickMirrorStart) {
            const mirror_mat = getMirrorMatrix(a.clickMirrorStart, mouse);
            g.context.uniformMatrix3fv(g.u_rotate, false, mirror_mat);
            a.shapes.filter(shape => shape.isSelected).forEach(shape => {
              drawSingle(shape);
            });
          }
          break;
        case "scale":
          if (a.clickScaleStart1 && a.clickScaleStart2) {
            const dx = (mouse.x - a.clickScaleStart2.x);
            const dy = (mouse.y - a.clickScaleStart2.y);

            const distX = a.clickScaleBaseDistanceX + dx;
            const distY = a.clickScaleBaseDistanceY + dy;


            const scale_mat = getScaleMatrix(a.clickScaleStart1, distX, distY, a.clickScaleBaseDistance, a.clickScaleShapeDistance);
            g.context.uniformMatrix3fv(g.u_scale, false, scale_mat);
            a.shapes.filter(shape => shape.isSelected).forEach(shape => {
              drawSingle(shape);
            });
          }
          break;
        case "offset": {
          let selected = a.shapes.filter(s => s.isSelected);
          let openEnds = selected.filter(s => {
            return !s.joinedStart || !s.joinedEnd;
          });

          if (openEnds.length === 0) {
            openEnds = selected;
          }
          let f = openEnds[0];
          let f1 = f.getClone();


          let vec = new Vector(f.start, f.end);
          let perpendicular = vec.getPerpendicularVector();

          let point = projectPointToVector(mouse, perpendicular);

          f1.start = f.start;
          f1.end = point;
          f1.color = [0, 1, 0, 1];
          f1.thickness = 5;
          let _array = [f, f1];

          let distVec = new Vector(f.start, point);
          let dist = distVec.length;

          // см. модуль page, операция offset
          a.currentInputField.value = dist / a.zlc;
          a.userInputValue = dist / a.zlc;
          a.currentInputField.focus();
          a.currentInputField.select();

          const move_mat = getMoveMatrix(f.start, point);
          drawSingle(f1);
          g.context.uniformMatrix3fv(g.u_move, false, move_mat);
          drawSingle(f);
        }
          break;
        case "guide": {
          let selected = getSelectedShapes();

          if (!checkSameType(selected) || selected.some(s => s.type === ObjectTypes.circle)) {
            console.error(">> Фигуры должны быть одного типа, для кругов операция не выполняется");
            return;
          }

          if (selected.map(s => s.type)[0] === ObjectTypes.rectangle) {
            if (selected.length > 1) {
              console.error(">> Операцию можно выполнить только для одного прямоугольника");
              // здесь нужно каким-то образом отсоединить обработчики событий, которые присоединились при нажатии G
              return;
            }
            selected = selected[0].getLines();
          }

          let openEnds = selected.filter(s => {
            return !s.startJ.id || !s.endJ.id;
          });

          if (openEnds.length === 0) {
            openEnds = selected;
          }
          let f = openEnds[0];

          if (f) {
            let f1 = f.getClone();

            let vec = new Vector(f.start, f.end);
            let perpendicular = vec.getPerpendicularVector();

            let point = projectPointToVector(mouse, perpendicular);

            f1.start = f.start;
            f1.end = point;
            f1.color = [0, 1, 0, 1];
            f1.thickness = 5;
            let _array = [f, f1];

            let distVec = new Vector(f.start, point);
            let dist = distVec.length;

            // см. модуль page, операция offset
            a.currentInputField.value = dist / a.zlc;
            a.userInputValue = dist / a.zlc;
            a.currentInputField.focus();
            a.currentInputField.select();

            const move_mat = getMoveMatrix(f.start, point);
            drawSingle(f1);
            g.context.uniformMatrix3fv(g.u_move, false, move_mat);
            drawSingle(f);
          }
        }
          break;


        case "move-route-part": {

          if (a.clickMoveRouteStart) {
            getSelectedShapes().forEach(selectedSeg => {

              const move_mat = getMoveMatrix(a.clickMoveRouteStart, mouse);
              let segClone = selectedSeg.getClone();

              // ********* показ перемещения соседних участков *********

              let joinedStart = findConnectedLineStart(selectedSeg, getDisplayedShapes());
              let joinedEnd = findConnectedLineEnd(selectedSeg, getDisplayedShapes());
              
              let pointStart, pointEnd;

              if (joinedStart && joinedEnd) {
                
                ({
                  pointStart,
                  pointEnd
                } = getPStartPEndProjWhenJoinedBoth(joinedStart, joinedEnd, move_mat, selectedSeg));


                let joinedStartClone = joinedStart.getClone();

                if (ifjoinedAtStart(joinedStart, selectedSeg)) {
                  joinedStartClone.start = pointStart;
                } else if (ifjoinedAtEnd(joinedStart, selectedSeg)) {
                  joinedStartClone.end = pointStart;
                }

                drawSingle(joinedStartClone);

                let joinedEndClone = joinedEnd.getClone();

                if (ifjoinedAtStart(joinedEnd, selectedSeg)) {
                  joinedEndClone.start = pointEnd;
                } else if (ifjoinedAtEnd(joinedEnd, selectedSeg)) {
                  joinedEndClone.end = pointEnd;
                }

                drawSingle(joinedEndClone);
              } else {
                if (joinedStart) {


                  ({ pointStart, pointEnd } = getPStartPEndProjWhenJoinedStart(joinedStart, selectedSeg, move_mat));

                  let joinedStartClone = joinedStart.getClone();

                  if (ifjoinedAtStart(joinedStart, selectedSeg)) {
                    joinedStartClone.start = pointStart;
                  } else if (ifjoinedAtEnd(joinedStart, selectedSeg)) {
                    joinedStartClone.end = pointStart;
                  }

                  drawSingle(joinedStartClone);

                }
                if (joinedEnd) {

                  ({ pointStart, pointEnd } = getPStartPEndProjWhenJoinedEnd(joinedEnd, selectedSeg, move_mat));


                  let joinedEndClone = joinedEnd.getClone();

                  if (ifjoinedAtStart(joinedEnd, selectedSeg)) {
                    joinedEndClone.start = pointEnd;
                  } else if (ifjoinedAtEnd(joinedEnd, selectedSeg)) {
                    joinedEndClone.end = pointEnd;
                  }

                  drawSingle(joinedEndClone);
                }
              }
              


              
              segClone.start = pointStart;
              segClone.end = pointEnd;

              drawSingle(segClone);


            });
          }
          break;
        }
        default:
          break;

      }
    }

  });

  function rotateFreeShape(move_mat) {

    /**
     * a.cpoints.p1 и a.cpoints.p2 назначаются при щелчке мыши в модуле operations
     */

    if (a.cpoints.p1 && a.cpoints.p2) {

      setCpointMod1(transformPointByMatrix3(move_mat, a.cpoints.p1));
      setCpointMod2(transformPointByMatrix3(move_mat, a.cpoints.p2));

      let segments = getDisplayedShapes().filter(s => s.type === ObjectTypes.line);

      for (const s of segments) {
        if (!s.isinSelectBoundary(a.cpointsMod.p1) && !s.isinSelectBoundary(a.cpointsMod.p2)) {
          continue;
        }

        if (s.isinSelectBoundary(a.cpointsMod.p1) && s.isinSelectBoundary(a.cpointsMod.p2)) {
          setCpointFinal1(a.cpoints.p1);
          setCpointFinal2(a.cpoints.p2);
          continue;
        }

        let rotateMat = getFreeShapeRotateMat(s, a.cpointsInitAngleDeg, a.cpointsMod.p1, a.cpointsMod.p2);
        

        setCpointFinal1(transformPointByMatrix3(rotateMat, a.cpointsMod.p1));
        setCpointFinal2(transformPointByMatrix3(rotateMat, a.cpointsMod.p2));

        if (rotateMat) {
          g.context.uniformMatrix3fv(g.u_rotate, false, rotateMat);
          getSelectedShapes().forEach(s => {
            drawSingle(s);
          });
        }
      }
    }
  }
}

export { handleMouseMove };


